import { d as defineVuesticPlugin } from "../../vue-plugin/utils/define-vuestic-plugin.js";
const VaAppCachePluginKey = Symbol("VaAppCachePlugin");
const CachePlugin = defineVuesticPlugin(() => ({
  install(app) {
    const cache = {
      colorContrast: {}
    };
    app.provide(VaAppCachePluginKey, cache);
  }
}));
export { CachePlugin as C, VaAppCachePluginKey as V };
//# sourceMappingURL=index.js.map
